import axios from 'axios';
const APP_BASE_URL = process.env.REACT_APP_BASE_URL;


export const getCategories = async () => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/project-categories`);
        return response;
    } catch (error) {
        throw error;
    }
}


export const getServiceList = async () => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/Project-category-services`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getShowServiceList = async () => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/Showcase-category-services`);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getSingleCatgeory = async (formData) => {
    try {
        const response = await axios.post(`${APP_BASE_URL}/services-project`, formData);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getTestimonials = async () => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/gettestimonials`);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getBrands = async () => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/getbrands`);
        return response;
    } catch (error) {
        throw error;
    }
}

// export const getSingleCat = async (id) => {
//     try {
//         const response = await axios.get(`${APP_BASE_URL}/project-categories/${id}`);
//         return response;
//     } catch (error) {
//         throw error;
//     }
// }

export const getSingleCat = async (formData) => {
    try {
        const response = await axios.post(`${APP_BASE_URL}/category-projects`, formData);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getTags = async (id) => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/tags`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getAddOns = async (id) => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/addons`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getBidAddOns = async (id) => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/bid_addons`);
        return response;
    } catch (error) {
        throw error;
    }
}


export const getShowCaseCat = async () => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/showcase-categories`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getSkills = async () => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/skills`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getOptions = async () => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/currency`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCommission = async (formData) => {
    try {
        const response = await axios.post(`${APP_BASE_URL}/get_milestone`, formData);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getDislikeOp = async () => {
    try {
        const response = await axios.get(`${APP_BASE_URL}/dislikeList`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const saveVisitor = async (formData) => {
    try {
        const response = await axios.post(`${APP_BASE_URL}/visitor`, formData);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getPageContent = async (formData) => {
    try {
        const response = await axios.post(`${APP_BASE_URL}/getpagecontent`, formData);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getBusinessHighlights = async (formData) => {
    try {
        const response = await axios.post(`${APP_BASE_URL}/getBusinessClient`, formData);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getQuickeasy1 = async (formData) => {
    try {
        const response = await axios.post(`${APP_BASE_URL}/getQuickeasy1`, formData);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getQuickeasy2 = async (formData) => {
    try {
        const response = await axios.post(`${APP_BASE_URL}/getQuickeasy2`, formData);
        return response;
    } catch (error) {
        throw error;
    }
}

export const get_support_faq = async (type) => {
    try {
        const response = await axios.post(`${APP_BASE_URL}/get-support-faq`, type);
        return response;
    } catch (error) {
        throw error;
    }
}


// pppppp 

export const getProjectCategory = async()=>{
    try {
        const response = await axios.get(`${APP_BASE_URL}/search-project`)
        return response
    } catch (error) {
        throw error
    }
}







// ppppend  


